
        <div class="clock simple" [style.border-color]="color">
            <div class="hours-container">
                <div class="hours" [ngStyle]="{transform: 'rotateZ(' + hourAngle + 'deg)'}"></div>
            </div>
            <div class="minutes-container">
                <div class="minutes" [ngStyle]="{transform: 'rotateZ(' + minuteAngle + 'deg)'}"></div>
            </div>
        </div>
    